import { HttpInterceptorFn } from '@angular/common/http';

const TOKEN_HEADER_KEY = 'Authorization'; // Ensure this matches your backend's expected header

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authToken = sessionStorage.getItem('Token'); // Retrieve the token from session storage
  if (authToken) {
    req = req.clone({
      setHeaders: { [TOKEN_HEADER_KEY]: `Bearer ${authToken}` },
    });
  }
  return next(req);
};